if (!customElements.get("inao-school-tabs")) {
  function openTabByHandle(trigger) {
    const tabs = document.querySelector("inao-school-tabs");
    const matchingBar = document.querySelector(
      `.inao-school-bar[data-trigger='${trigger}']`
    );
    console.log(matchingBar);
    tabs.onBarClick(matchingBar);
  }
  class InaoSchoolTabs extends HTMLElement {
    constructor() {
      super();

      this.initElements();
      this.initEventListeners();
      this.setFirstMatchedTab();

      const urlParams = new URLSearchParams(window.location.search);
      const openTab = urlParams.get('openTab');
      if (openTab) {
        const matchingBar = this.querySelector(`.inao-school-bar[data-trigger='${openTab}']`);
        if (matchingBar) {
          this.onBarClick(matchingBar);
        }
      }
    }

    initElements() {
      this.bars = this.querySelectorAll(".inao-school-bar");
      this.tabs = document.querySelectorAll(".inao-school-tab");
    }

    initEventListeners() {
      this.bars.forEach((bar) => {
        bar.addEventListener("click", () => this.onBarClick(bar));
        bar.addEventListener("focus", (e) => {
          e.preventDefault();
          this.onBarClick(bar);
        });
      });
    }

    onBarClick(bar) {
      window.scrollTo(0, 0, { behavior: "smooth" });
      this.closeAll();
      this.toggleMatchingTab(bar);
    }

    toggleMatchingTab(bar) {
      const matchingTab = this.findMatchingTab(bar.dataset.trigger);
      if (matchingTab) {
        this.toggleBarAndTab(bar, matchingTab);
      }
    }

    findMatchingTab(triggerClass) {
      return [...this.tabs].find((tab) => tab.classList.contains(triggerClass));
    }

    toggleBarAndTab(bar, tab) {
      bar.setAttribute("data-toggle", "");
      bar.setAttribute("aria-selected", "true");
      tab.setAttribute("data-toggle", "");
    }

    closeAll() {
      this.bars.forEach((bar) => {
        bar.removeAttribute("data-toggle");
        bar.setAttribute("aria-selected", "false");
      });
      this.tabs.forEach((tab) => tab.removeAttribute("data-toggle"));
    }

    setFirstMatchedTab() {
      this.closeAll();
      [...this.bars].some((bar) => {
        const matchingTab = this.findMatchingTab(bar.dataset.trigger);
        if (matchingTab) {
          this.toggleBarAndTab(bar, matchingTab);
          return true;
        }
      });
    }
  }

  customElements.define("inao-school-tabs", InaoSchoolTabs);
}

if (!customElements.get("custom-video")) {
  class CustomVideo extends HTMLElement {
    constructor() {
      super();

      this.video = this.querySelector("video");
      this.iframe = this.querySelector("iframe");
      this.vimeoVideoUrl = this.dataset.vimeoVideoUrl;

      this.observerTarget = this.video || this.iframe;
      if (!this.observerTarget) {
        return;
      }

      const threshold = window.innerWidth < 768 ? 0.1 : 0.9;

      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              document.querySelectorAll("custom-video[data-state='playing']").forEach((video) => {
                video.pause();
              });
              this.play();
            } else {
              this.pause();
            }
          });
        },
        { threshold }
      );

      observer.observe(this.observerTarget);
    }

    play() {
      if (this.video) {
        const played = this.video.play();
        if (played && typeof played.catch === "function") {
          played.catch(() => {});
        }
        this.setAttribute("data-state", "playing");
        return;
      }
      if (this.iframe.getAttribute("src") != this.vimeoVideoUrl) {
        this.iframe.setAttribute("src", this.vimeoVideoUrl);
        this.setAttribute("data-state", "playing");
      }
    }

    pause() {
      if (this.video) {
        this.video.pause();
        this.setAttribute("data-state", "paused");
        return;
      }
      if (this.iframe.hasAttribute("src")) {
        this.iframe.removeAttribute("src");
        this.setAttribute("data-state", "paused");
      }
    }

  }

  customElements.define("custom-video", CustomVideo);
}

if (!customElements.get("element-table")) {
  class ElementTable extends HTMLElement {
    constructor() {
      super();

      this.table = this;
      this.squares = this.querySelectorAll(".inao-ingredients__square");
      this.popovers = this.querySelectorAll(".inao-ingredients__popover");

      this.draggedElement = null;

      this.initDragAndDrop();
    }

    initDragAndDrop() {
      this.squares.forEach((square) => {
        square.addEventListener("dragstart", this.handleDragStart.bind(this));
        square.addEventListener("dragover", this.handleDragOver.bind(this));
        square.addEventListener("drop", this.handleDrop.bind(this));
        square.addEventListener("dragend", this.handleDragEnd.bind(this));

        square.addEventListener("click", () => {
          this.togglePopover(square);
        });
      });

      this.querySelectorAll(".inao-ingredients__popover-toggle").forEach(
        (arrow) => {
          arrow.addEventListener("click", (_) => {
            const popover = arrow.closest(".inao-ingredients__popover");
            const connectingSquare = Array.from(this.squares).find(
              (s) => s.dataset.blockId === popover.dataset.blockId
            );
            this.togglePopover(connectingSquare);
          });
        }
      );
    }

    handleDragStart(e) {
      this.draggedElement = e.currentTarget;
      e.dataTransfer.effectAllowed = "move";
      this.draggedElement.setAttribute("data-dragging", "");
    }

    handleDragOver(e) {
      e.preventDefault();
      const target = e.currentTarget;

      // Calculate the middle points of the target
      const targetRect = target.getBoundingClientRect();
      const targetMiddleX = targetRect.left + targetRect.width / 2;
      const targetMiddleY = targetRect.top + targetRect.height / 2;

      // Determine whether to insert before or after the target element
      const shouldInsertBefore =
        e.clientX < targetMiddleX && e.clientY < targetMiddleY;

      if (target !== this.draggedElement) {
        if (shouldInsertBefore) {
          this.table.insertBefore(this.draggedElement, target);
        } else {
          this.table.insertBefore(this.draggedElement, target.nextSibling);
        }
      }
    }

    handleDrop(e) {
      e.preventDefault();
      if (this.draggedElement) {
        this.draggedElement.removeAttribute("data-dragging");
        this.updateIndices();
        this.draggedElement = null;
      }
    }

    handleDragEnd() {
      if (this.draggedElement) {
        this.draggedElement.removeAttribute("data-dragging");
        this.draggedElement = null;
      }
    }

    updateIndices() {
      const squares = this.table.querySelectorAll(
        ".inao-ingredients__square-index"
      );
      squares.forEach((indexElement, i) => {
        indexElement.textContent = String(i + 1).padStart(2, "0");
      });
    }

    togglePopover(square) {
      // Check if the square already has the 'data-popover' attribute
      const isPopoverOpen = square.dataset.open === "true";
      const popoverEl = document.querySelector(
        `.inao-ingredients__popover[data-block-id="${square.dataset.blockId}"]`
      );

      // Close all popovers

      Array.from(this.squares)
        .filter((s) => s != square)
        .forEach((s) => s.setAttribute("data-open", false));
      Array.from(this.popovers)
        .filter((p) => p != popoverEl)
        .forEach((p) => p.setAttribute("data-open", false));

      popoverEl.setAttribute("data-open", !isPopoverOpen);
      square.setAttribute("data-open", !isPopoverOpen);

      if (window.screen.width < 768) {
        if (isPopoverOpen) {
          square.scrollIntoView({ behavior: "smooth" });
        } else {
          popoverEl.scrollIntoView({ behavior: "smooth" });
        }
      }

      const containerRect = this.getBoundingClientRect();
      const popoverRect = square.firstElementChild.getBoundingClientRect();

      // Adjust positioning of the popover
      if (containerRect.left >= popoverRect.left) {
        square.firstElementChild.style.right = "";
        square.firstElementChild.style.left = "0";
      }

      if (containerRect.right <= popoverRect.right) {
        square.firstElementChild.style.left = "";
        square.firstElementChild.style.right = "0";
      }
    }
  }
  customElements.define("element-table", ElementTable);
}

if (!customElements.get("custom-accordion")) {
  class CustomAccordion extends HTMLElement {
    constructor() {
      super();
      this.initElements();
      this.initEventListeners();
    }

    initElements() {
      this.accordionNavigation = this.querySelectorAll(
        ".custom-accordion__navigation"
      );
      this.accordionItems = this.querySelectorAll(".custom-accordion__item");
      this.accordionBars = this.querySelectorAll(".custom-accordion__bar");
      this.accordionContents = this.querySelectorAll(
        ".custom-accordion__content"
      );
    }

    initEventListeners() {
      this.addClickListeners(
        this.accordionNavigation,
        this.handleToggleNavigation.bind(this)
      );
      this.addClickListeners(
        this.accordionBars,
        this.handleToggleBar.bind(this)
      );
    }

    addClickListeners(elements, handler) {
      elements.forEach((el, index) => {
        el.addEventListener("click", () => handler(index));
      });
    }

    handleToggleNavigation(index) {
      this.handleToggle(
        index,
        this.accordionNavigation,
        this.accordionItems,
        true
      );
    }

    handleToggleBar(index) {
      this.handleToggle(
        index,
        this.accordionBars,
        this.accordionContents,
        false
      );
    }

    handleToggle(index, toggleElements, targetElements, resetBoth) {
      const isActive = this.isActive(toggleElements[index]);
      if (resetBoth) this.resetAll();
      this.setActive(toggleElements[index], !isActive);
      this.setActive(targetElements[index], !isActive);
    }

    isActive(element) {
      return element.dataset.toggle === "true";
    }

    resetAll() {
      this.resetElements(this.accordionNavigation);
      this.resetElements(this.accordionItems);
      this.resetElements(this.accordionBars);
      this.resetElements(this.accordionContents);
    }

    resetElements(elements) {
      elements.forEach((el) => this.setActive(el, false));
    }

    setActive(element, isActive) {
      element.setAttribute("data-toggle", isActive);
    }
  }

  customElements.define("custom-accordion", CustomAccordion);
}
